/**
 * Sprint 23.8 → 26.0 — workspace tasks hook.
 *
 * Wraps `list_workspace_tasks` — the cross-agent active-tasks roll-up for the
 * hero section and the Tasks tab. Polled every 30s (status data). Pass
 * `limit: 5` for the hero; omit for the full tab list.
 */

import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";
import { useAuth } from "../../lib/hooks/use-auth";
import type { WorkspaceTasksResult } from "../../lib/types";

const POLL_MS = 30_000;

export function useWorkspaceTasks(opts?: {
  limit?: number;
  includeDone?: boolean;
}) {
  const { currentWorkspaceId } = useAuth();
  return useQuery<WorkspaceTasksResult>({
    queryKey: [
      "workspace-tasks",
      currentWorkspaceId,
      opts?.limit ?? "all",
      opts?.includeDone ?? false,
    ],
    queryFn: () => mcpClient.listWorkspaceTasks(opts),
    enabled: !!currentWorkspaceId,
    staleTime: 15_000,
    refetchInterval: POLL_MS,
    refetchOnWindowFocus: true,
  });
}
